import { positionClasses } from "./tailwindClasses";
const getPositionClass = (position, viewport) => {
  if (!position) return null;
  return viewport ? positionClasses[viewport][position] : positionClasses[position];
};
export default getPositionClass;